import { useState } from "react";
import { useParams } from "react-router-dom";

import { DataTable } from "@krea/shared/design-system/data-table/data-table";

import { useGetLenderCompanyUsers } from "@/features/users/hooks/use-get-lender-company-users";
import type { ILenderUser } from "@/features/users/types";

import { EditTeamMemberModal } from "../components/team/edit-team-member-modal";
import { columns } from "../components/team/team-columns";
import { TeamHeaderSection } from "../components/team/team-header";

export const TeamPage = () => {
  const { lenderCompanyId } = useParams();
  const [userToEdit, setUserToEdit] = useState<ILenderUser | null>(null);

  const {
    data: users,
    isLoading,
    isError,
  } = useGetLenderCompanyUsers(Number(lenderCompanyId));

  return (
    <div className="space-y-8">
      <TeamHeaderSection onUserInvited={setUserToEdit} />

      {userToEdit && (
        <EditTeamMemberModal
          isOpen
          setIsOpen={(open) => {
            if (!open) setUserToEdit(null);
          }}
          user={userToEdit}
        />
      )}

      <section>
        {isLoading && (
          <div className="p-6 text-sm text-gray-500">Loading team members…</div>
        )}
        {users && !isError && <DataTable columns={columns} data={users} />}
        {!isLoading && !isError && users?.length === 0 && (
          <div className="p-6 text-sm text-gray-500">
            No team members found.
          </div>
        )}
      </section>
    </div>
  );
};
